<form [formGroup]="activeBlock$()" class="block-form__container">
  <mat-card class="block-form__card">
    <mat-card-title>
      <div class="title">
        <div class="eiq-id-badge">
          <fa-icon [icon]="blockTypeConfig[activeBlock$().value.type].icon"></fa-icon>
          <span>{{ activeBlock$().value.id }}</span>
        </div>
        <span class="fs__md fw__500">{{ blockTypeConfig[activeBlock$().value.type].text }}</span>
      </div>

      <div class="actions">
        <eiq-button
          [matMenuTriggerFor]="menu"
          [testId]="'block-commands-' + activeBlock$().value.id"
          [title]="'Open commands menu'"
          [icon]="faEllipsisVertical"
          [color]="'light'"
          [style]="'fab'"
        ></eiq-button>

        <mat-menu #menu="matMenu">
          <button data-testid="block-delete-menu-item" mat-menu-item color="warn" (click)="onRemove()">
            <fa-icon [icon]="faTrashCan"></fa-icon>
            <span class="fs__sm fw__500">Delete</span>
          </button>
        </mat-menu>
      </div>
    </mat-card-title>

    <mat-card-content>
      @if (hasBlockActions$()) {
        <div class="block-form__actions">
          <div class="block-form__actions__buttons">
            @if (activeBlock$().value.type === blockType.MultiBlock) {
              <button
                mat-icon-button
                title="Open Blocks Quotas"
                data-testid="block-quotas-open-button"
                [color]="activeTab$() === sideTabs.Quotas ? 'primary' : activeBlock$().value.quotas.length > 0 ? 'alert' : 'light'"
                class="settings-btn"
                (click)="onOpenSideTab(sideTabs.Quotas)"
              >
                <fa-icon [icon]="faSquarePollHorizontal"></fa-icon>
              </button>
            }

            @if (activeAllowsConditionals$()) {
              <button
                mat-icon-button
                title="Open Conditions"
                data-testid="block-conditions-open-button"
                [color]="activeTab$() === sideTabs.Conditions ? 'primary' : activeBlock$().value.visibleWhen.length > 0 ? 'alert' : 'light'"
                class="settings-btn"
                (click)="onOpenSideTab(sideTabs.Conditions)"
              >
                <fa-icon [icon]="faCodeBranch"></fa-icon>
              </button>
            }
          </div>
        </div>
      }

      <div class="block-form__common">
        <div class="editor-question-form__input">
          <span class="label fs__md">Title</span>
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
            <input matInput formControlName="title" data-testid="block-title-input" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="editor-question-form__input">
          <span class="label fs__md">Add Notes: <span class="fs__xs caption">(Optional)</span></span>
          <mat-form-field appearance="outline">
            <input matInput formControlName="description" data-testid="block-description-input" autocomplete="off" />
          </mat-form-field>
        </div>

        <mat-divider class="block-form__divider"></mat-divider>

        @switch (activeBlock$().value.type) {
          @case (blockType.MultiBlock) {
            <empathy-parent-block-form [activeBlock]="activeBlock$()"></empathy-parent-block-form>
          }
          @case (blockType.LoopParent) {
            <empathy-parent-block-form [activeBlock]="activeBlock$()" />
          }
          @case (blockType.Loop) {
            <empathy-loop-block-form [activeBlock]="activeBlock$()"></empathy-loop-block-form>
          }
          @case (blockType.Group) {
            <empathy-group-block-form [activeBlock]="activeBlock$()"></empathy-group-block-form>
          }
        }
      </div>
    </mat-card-content>
  </mat-card>
</form>
